<!-- View Mode -->
<ng-container *ngIf="!srv.editing">
  <nz-space class="space">
    <div class="btn-one">
      <app-page-how-to-toolbar-btn></app-page-how-to-toolbar-btn>
      <span *ngIf="showSubmitEInvoiceButton" class="submit-einvoice-toolbar hidden-mobile" nz-tooltip
        [nzTooltipTitle]="submitEInvoiceDisabled ? einvDimmedReason : null">
        <button type="button" nz-button (click)="promptSubmitModel()" [disabled]="submitEInvoiceDisabled"
          [nzLoading]="processingEdit">
          <span nz-icon [nzIconfont]="'icon-submit'"></span>
          Submit E-Invoice
        </button>
      </span>
      <button type="button" nz-button *ngIf="canCreate" (click)="gotoNew()" [disabled]="srv.loading">
        Add
      </button>

      <button type="button" nz-button
        *ngIf="canEdit && allowEdit && (!srv.parkAndPost || !supportParkAndPost || srv._data.documentStatus < 2 || canApprove)"
        nzType="primary" (click)="edit()" [disabled]="srv.loading" [nzLoading]="processingEdit">
        Edit
      </button>

    </div>

    <div class="btn-two">
      @if (allowSend) {
      <button type="button" nz-button nzTrigger="click" nz-dropdown [nzDropdownMenu]="sendOption"
        [disabled]="saving || srv.loading || disableSend" [nzDisabled]="saving || srv.loading || disableSend"
        class="ml-sm hidden-mobile">
        Send
      </button>

      <nz-dropdown-menu #sendOption="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item (click)="chooseSender('email', false)">
            <span nz-icon nzType="mail" nzTheme="outline"></span>
            Email
          </li>
          <li nz-menu-item (click)="chooseSender('whatsapp', false)">
            <span nz-icon nzType="whats-app" nzTheme="outline"></span>
            WhatsApp
          </li>
          <li nz-menu-item (click)="chooseSender('telegram', false)">
            <span nz-icon [nzIconfont]="'icon-telegram'"></span>
            Telegram
          </li>
          <li nz-menu-item (click)="chooseSender('link', false)">
            <span nz-icon nzType="link" nzTheme="outline"></span>
            Link
          </li>
        </ul>
      </nz-dropdown-menu>
      }
    </div>

    <div class="btn-three">
      <div class="ml-sm mr-sm">
        <ng-container *ngIf="reportTypes?.length && allowPreview">
          <app-preview-doc #reportPreview [docCode]="srv.code" [reportTypes]="reportTypes" [filter]="reportFilter"
            [validate]="validate" [einvoiceControl]="einvControl" [disabled]="disablePreview"
            [additionalData]="additionalData"></app-preview-doc>
        </ng-container>
      </div>

      <button type="button" nz-button nz-dropdown [nzDropdownMenu]="viewMenu" nzPlacement="bottomRight"
        [disabled]="srv.loading">
        <span nz-icon nzType="ellipsis"> </span>
      </button>
    </div>
  </nz-space>

  <nz-dropdown-menu #viewMenu="nzDropdownMenu">
    <ng-container *ngTemplateOutlet="viewDropdownHeader"></ng-container>
    <ul nz-menu>
      <li nz-menu-item *ngIf="showSubmitEInvoiceButton" class="hidden-pc" (click)="promptSubmitModel()"
        [nzDisabled]="submitEInvoiceDisabled" nz-tooltip [nzTooltipTitle]="einvDimmedReason || null">
        <span nz-icon [nzIconfont]="'icon-submit'"></span>
        Submit E-Invoice
      </li>
      <li nz-menu-divider *ngIf="showSubmitEInvoiceButton" class="hidden-pc"></li>
      <ng-container *ngIf="allowSend">
        <li nz-menu-item class="hidden-pc" [nzDisabled]="saving || srv.loading || disableSend"
          (click)="chooseSender('email', false)">
          <span nz-icon nzType="mail" nzTheme="outline"></span>
          Send via Email
        </li>
        <li nz-menu-item class="hidden-pc" [nzDisabled]="saving || srv.loading || disableSend"
          (click)="chooseSender('whatsapp', false)">
          <span nz-icon nzType="whats-app" nzTheme="outline"></span>
          Send via WhatsApp
        </li>
        <li nz-menu-item class="hidden-pc" [nzDisabled]="saving || srv.loading || disableSend"
          (click)="chooseSender('telegram', false)">
          <span nz-icon [nzIconfont]="'icon-telegram'"></span>
          Send via Telegram
        </li>
        <li nz-menu-item class="hidden-pc" [nzDisabled]="saving || srv.loading || disableSend"
          (click)="chooseSender('link', false)">
          <span nz-icon nzType="link" nzTheme="outline"></span>
          Send Link
        </li>
      </ng-container>
      <li nz-menu-divider class="hidden-pc" *ngIf="allowSend"></li>
      <li nz-menu-item (click)="reload()">Reload</li>
      <ng-container *ngIf="allowEdit">
        <li *ngIf="allowEdit" nz-menu-item (click)="clone()" [acl]="srv.aclKey + '.create'">
          Clone
        </li>
        <li *ngIf="allowEdit && markAsClosedIsVisible()" nz-menu-item (click)="MarkAsClosed()"
          [acl]="srv.aclKey + '.create'">
          Mark as Closed
        </li>
        <li *ngIf="allowEdit && reOpenIsVisible()" nz-menu-item (click)="Reopen()" [acl]="srv.aclKey + '.create'">
          Reopen
        </li>
        <li *ngIf="!srv._data.isCancelled && allowVoid" nz-menu-item [acl]="srv.aclKey + '.update'"
          (click)="handleVoidClick()" [nzDisabled]="srv._data.consolidatedDocCode">
          Cancel
        </li>
        <li *ngIf="srv._data.isCancelled" nz-menu-item [acl]="srv.aclKey + '.update'" (click)="handleDevoidClick()"
          [nzDisabled]="srv._data.eInvoiceStatus == 'Cancelled' && isConvertDoc">
          Undo Cancel
        </li>

        <li *ngIf="
           this.options.allowPDC === true &&
           (srv.aclKey === 'aror' || srv.aclKey === 'appv') &&
           !srv._data.isPostDatedCheque
           " nz-menu-item [acl]="srv.aclKey + '.update'" (click)="handleSavePdcClick()">
          Mark as Post Dated Cheque
        </li>
        <li *ngIf="
           this.options.allowPDC === true &&
           (srv.aclKey === 'aror' || srv.aclKey === 'appv') &&
           srv._data.isPostDatedCheque
           " nz-menu-item [acl]="srv.aclKey + '.update'" (click)="handleSaveUnmarkPdcClick()">
          Unmark Post Dated Cheque
        </li>

        <li *ngIf="
            this.options.allowBouncedCheque === true &&
            !srv._data.isBouncedCheque
            " nz-menu-item [acl]="srv.aclKey + '.update'" (click)="handleBounceMarkClick()">
          Mark as Bounced Cheque
        </li>
        <li *ngIf="
            this.options.allowBouncedCheque === true &&
            srv._data.isBouncedCheque
            " nz-menu-item [acl]="srv.aclKey + '.update'" (click)="handleClearChqClick()">
          Clear Cheque
        </li>
      </ng-container>

      <li nz-menu-item [acl]="srv.aclKey + '.delete'" (click)="handleDeleteClick()" [nzDisabled]="dimmedDelete"
        class="text-error">
        Delete
      </li>
      <li nz-menu-divider></li>
      <ng-container *ngIf="
        srv.aclKey === 'qt' &&
        srv._data.isCancelled === false &&
        srv._data.transferStatus !== 2
        ">
        <li *ngIf="this.acl.can('m3.131072') && this.acl.can('so.view') && !srv._data.isClosed" nz-menu-item
          (click)="confirmTransferToSo()">
          Transfer to Sales Order
        </li>
        <li *ngIf="this.acl.can('m3.262144') && this.acl.can('do.view') && !srv._data.isClosed" nz-menu-item
          (click)="confirmTransferToDo()">
          Transfer to Delivery Order
        </li>
        <li *ngIf="this.acl.can('m3.524288') && this.acl.can('sinv.view') && !srv._data.isClosed" nz-menu-item
          (click)="confirmTransferToSinv()">
          Transfer to Sales Invoice
        </li>
        <li *ngIf="this.acl.can('m1.8192') && this.acl.can('cs.view') && !srv._data.isClosed" nz-menu-item
          (click)="confirmTransferToCs()">
          Transfer to Cash Sale
        </li>

        <li nz-menu-divider></li>
      </ng-container>
      <ng-container *ngIf="
          srv.aclKey === 'so' &&
          srv._data.isCancelled === false &&
          srv._data.transferStatus !== 2
        ">
        <li *ngIf="this.acl.can('m3.262144') && this.acl.can('do.view') && !srv._data.isClosed" nz-menu-item
          (click)="confirmTransferToDo()">
          Transfer to Delivery Order
        </li>
        <li *ngIf="this.acl.can('m3.524288') && this.acl.can('sinv.view') && !srv._data.isClosed" nz-menu-item
          (click)="confirmTransferToSinv()">
          Transfer to Sales Invoice
        </li>
        <li *ngIf="this.acl.can('m1.8192') && this.acl.can('cs.view') && !srv._data.isClosed  " nz-menu-item
          (click)="confirmTransferToCs()">
          Transfer to Cash Sale
        </li>

        <li nz-menu-divider></li>
      </ng-container>
      <ng-container *ngIf="
          srv.aclKey === 'do' &&
          srv._data.isCancelled === false &&
          srv._data.transferStatus !== 2
        ">
        <li *ngIf="this.acl.can('m3.524288') && this.acl.can('sinv.view') && !srv._data.isClosed" nz-menu-item
          (click)="confirmTransferToSinv()">
          Transfer to Sales Invoice
        </li>
        <li *ngIf="this.acl.can('m1.8192') && this.acl.can('cs.view') && !srv._data.isClosed" nz-menu-item
          (click)="confirmTransferToCs()">
          Transfer to Cash Sale
        </li>

        <li nz-menu-divider></li>
      </ng-container>
      <ng-container *ngIf="
          srv.aclKey === 'cs' &&
          srv._data.isCancelled === false &&
          srv._data.transferStatus !== 2
        ">
        <li *ngIf="this.acl.can('m3.4194304') && this.acl.can('cs.view') && !this.isPostToAR && !srv._data.isClosed"
          [nzDisabled]="srv._data.documentStatus !== 2" nz-menu-item (click)="confirmTransferToCsr()">
          Transfer to Cash Sale Refund
        </li>

        <li nz-menu-divider *ngIf="!this.isPostToAR"></li>
      </ng-container>
      <ng-container *ngIf="
          srv.aclKey === 'pr' &&
          srv._data.isCancelled === false &&
          srv._data.transferStatus !== 2
        ">
        <li *ngIf="this.acl.can('m3.16777216') && this.acl.can('po.view') && !srv._data.isClosed" nz-menu-item
          (click)="confirmTransferToPo()">
          Transfer to Purchase Order
        </li>
        <li *ngIf="this.acl.can('m3.33554432') && this.acl.can('grn.view') && !srv._data.isClosed" nz-menu-item
          (click)="confirmTransferToGrn()">
          Transfer to Goods Received Note
        </li>
        <li *ngIf="this.acl.can('m3.67108864') && this.acl.can('pinv.view') && !srv._data.isClosed" nz-menu-item
          (click)="confirmTransferToPinv()">
          Transfer to Purchase Invoice
        </li>
        <li *ngIf="this.acl.can('m3.536870912') && this.acl.can('cp.view') && !srv._data.isClosed" nz-menu-item
          (click)="confirmTransferToCp()">
          Transfer to Cash Purchase
        </li>

        <li nz-menu-divider></li>
      </ng-container>
      <ng-container *ngIf="
        srv.aclKey === 'po' &&
        srv._data.isCancelled === false &&
        srv._data.transferStatus !== 2
        ">
        <li *ngIf="this.acl.can('m3.33554432') && this.acl.can('grn.view') && !srv._data.isClosed" nz-menu-item
          (click)="confirmTransferToGrn()">
          Transfer to Goods Received Note
        </li>
        <li *ngIf="this.acl.can('m3.67108864') && this.acl.can('pinv.view') && !srv._data.isClosed" nz-menu-item
          (click)="confirmTransferToPinv()">
          Transfer to Purchase Invoice
        </li>
        <li *ngIf="this.acl.can('m3.536870912') && this.acl.can('cp.view') && !srv._data.isClosed " nz-menu-item
          (click)="confirmTransferToCp()">
          Transfer to Cash Purchase
        </li>

        <li nz-menu-divider></li>
      </ng-container>
      <ng-container *ngIf="
        srv.aclKey === 'grn' &&
        srv._data.isCancelled === false &&
        srv._data.transferStatus !== 2
        ">
        <li *ngIf="this.acl.can('m3.67108864') && this.acl.can('pinv.view') && !srv._data.isClosed" nz-menu-item
          (click)="confirmTransferToPinv()">
          Transfer to Purchase Invoice
        </li>
        <li *ngIf="this.acl.can('m3.536870912') && this.acl.can('cp.view') && !srv._data.isClosed" nz-menu-item
          (click)="confirmTransferToCp()">
          Transfer to Cash Purchase
        </li>

        <li nz-menu-divider></li>
      </ng-container>
      <ng-container *ngIf="
          srv.aclKey === 'cp' &&
          srv._data.isCancelled === false &&
          srv._data.transferStatus !== 2
        ">
        <li *ngIf="this.acl.can('m3.1073741824') && this.acl.can('cp.view') && !this.isPostToAP && !srv._data.isClosed"
          [nzDisabled]="srv._data.documentStatus !== 2" nz-menu-item (click)="confirmTransferToCpf()">
          Transfer to Cash Purchase Refund
        </li>

        <li nz-menu-divider *ngIf="!this.isPostToAP"></li>
      </ng-container>
      <ng-container *ngIf="(recurringAcls.indexOf(srv.aclKey) > -1) && id !== '0'">
        <li nz-menu-item [acl]="srv.aclKey + '.create'" (click)="handleMakeRecurringTransactionClick()">
          Make Recurring Transaction
        </li>
      </ng-container>

      @if (showCopyToButton()) {
      <li nz-menu-item (click)="onCopyTo()">
        Copy to
      </li>
      <li nz-menu-divider></li>
      }

      <li nz-menu-item (click)="close()">Close</li>
    </ul>
  </nz-dropdown-menu>
</ng-container>

<!-- Edit Mode -->
<ng-container *ngIf="srv.editing">
  <nz-space class="space">
    <div class="btn-one">
      <app-page-how-to-toolbar-btn></app-page-how-to-toolbar-btn>
      <button type="button" nz-button (click)="cancel()" [disabled]="srv.loading || saving">
        Cancel
      </button>
      @if (!srv.parkAndPost || !supportParkAndPost || (canApprove || srv._data.documentStatus < 2)) { <button
        type="button" nz-button (click)="save()" [disabled]="!saving && srv.loading" [nzLoading]="saving">
        <span nz-icon nzType="edit" nzTheme="outline" *ngIf="srv.modified"></span>
        Save
        </button>
        }
    </div>

    <div class="btn-two">
      @if (canCreate || canEdit) {
      @if (srv.parkAndPost && srv._data.documentStatus < 2) { @if (canApprove) { <button type="button" nz-button
        nzType="primary" (click)="saveAndApprove()" [disabled]="saving || srv.loading" class="ml-sm hidden-mobile">
        Save & Approve
        </button>
        } @else {
        <button type="button" nz-button nzType="primary" (click)="submitForApproval()"
          [disabled]="saving || srv.loading" class="ml-sm hidden-mobile">
          Submit for Approval
        </button>
        }
        } @else {
        @if (!srv.parkAndPost || !supportParkAndPost || canApprove) {
        @if (srv.transactionType) {
        <button type="button" nz-button nzType="primary" nzTrigger="click" nz-dropdown [nzDropdownMenu]="sendOption"
          [disabled]="saving || srv.loading || disableSend" [nzDisabled]="saving || srv.loading || disableSend"
          class="ml-sm">
          Save & Send
        </button>
        }
        }
        }
        }

        <button type="button" title="More" style="margin: unset" nz-button [disabled]="srv.loading" nz-dropdown
          [nzDropdownMenu]="saveMenu">
          <span nz-icon nzType="down"></span>
        </button>
    </div>
  </nz-space>

  <nz-dropdown-menu #sendOption="nzDropdownMenu">
    <ul nz-menu>
      <li nz-menu-item (click)="chooseSender('email')">
        <span nz-icon nzType="mail" nzTheme="outline"></span>
        Email
      </li>
      <li nz-menu-item (click)="chooseSender('whatsapp')">
        <span nz-icon nzType="whats-app" nzTheme="outline"></span>
        WhatsApp
      </li>
      <li nz-menu-item (click)="chooseSender('telegram')">
        <span nz-icon [nzIconfont]="'icon-telegram'"></span>
        Telegram
      </li>
      <li nz-menu-item (click)="chooseSender('link')">
        <span nz-icon nzType="link" nzTheme="outline"></span>
        Link
      </li>
    </ul>
  </nz-dropdown-menu>

  <nz-dropdown-menu #saveMenu="nzDropdownMenu">
    <ng-container *ngTemplateOutlet="editDropdownHeader"></ng-container>
    <ul nz-menu>
      <ng-container *ngIf="this.options.allowPDC === true">
        <li *ngIf="!srv._data.isPostDatedCheque" nz-menu-item [acl]="srv.aclKey + '.update'" (click)="handlePdcClick()">
          Mark as Post Dated Cheque
        </li>
        <li *ngIf="srv._data.isPostDatedCheque" nz-menu-item [acl]="srv.aclKey + '.update'"
          (click)="handleUnmarkPdcClick()">
          Unmark Post Dated Cheque
        </li>
        <li nz-menu-divider></li>
      </ng-container>

      <!-- # Sales -->
      <ng-container *ngIf="srv.aclKey === 'so' && srv._data.isCancelled === false">
        <li *ngIf="this.acl.can('m3.65536')" nz-menu-item (click)="showQtTransferModal()">
          Transfer from Quotation
        </li>
        <li nz-menu-divider></li>
      </ng-container>

      <ng-container *ngIf="srv.aclKey === 'do' && srv._data.isCancelled === false">
        <li *ngIf="this.acl.can('m3.65536')" nz-menu-item (click)="showQtTransferModal()">
          Transfer from Quotation
        </li>
        <li *ngIf="this.acl.can('m3.131072')" nz-menu-item (click)="showSoTransferModal()">
          Transfer from Sales Order
        </li>
        <li nz-menu-divider></li>
      </ng-container>

      <ng-container *ngIf="srv.aclKey === 'sinv' && srv._data.isCancelled === false">
        <li *ngIf="this.acl.can('m3.65536')" nz-menu-item (click)="showQtTransferModal()">
          Transfer from Quotation
        </li>
        <li *ngIf="this.acl.can('m3.131072')" nz-menu-item (click)="showSoTransferModal()">
          Transfer from Sales Order
        </li>
        <li *ngIf="this.acl.can('m3.262144')" nz-menu-item (click)="showDoTransferModal()">
          Transfer from Delivery Order
        </li>
        <li nz-menu-divider></li>
      </ng-container>

      <ng-container *ngIf="srv.aclKey === 'cs' && srv._data.isCancelled === false">
        <li *ngIf="this.acl.can('m3.65536')" nz-menu-item (click)="showQtTransferModal()">
          Transfer from Quotation
        </li>
        <li *ngIf="this.acl.can('m3.131072')" nz-menu-item (click)="showSoTransferModal()">
          Transfer from Sales Order
        </li>
        <li *ngIf="this.acl.can('m3.262144')" nz-menu-item (click)="showDoTransferModal()">
          Transfer from Delivery Order
        </li>
        <li nz-menu-divider></li>
      </ng-container>

      <ng-container *ngIf="srv.aclKey === 'csr' && srv._data.isCancelled === false">
        <li *ngIf="this.acl.can('m1.8192')" nz-menu-item (click)="showCSTransferModal()">
          Transfer from Cash Sale
        </li>
        <li nz-menu-divider></li>
      </ng-container>
      <!-- Sales # -->
      <!-- # Purchase -->
      <ng-container *ngIf="srv.aclKey === 'po' && srv._data.isCancelled === false">
        <li *ngIf="this.acl.can('m3.8388608')" nz-menu-item (click)="showPrTransferModal()">
          Transfer from Purchase Requisition
        </li>
        <li nz-menu-divider></li>
      </ng-container>

      <ng-container *ngIf="srv.aclKey === 'grn' && srv._data.isCancelled === false">
        <li *ngIf="this.acl.can('m3.8388608')" nz-menu-item (click)="showPrTransferModal()">
          Transfer from Purchase Requisition
        </li>
        <li *ngIf="this.acl.can('m3.16777216')" nz-menu-item (click)="showPoTransferModal()">
          Transfer from Purchase Order
        </li>
        <li nz-menu-divider></li>
      </ng-container>

      <ng-container *ngIf="srv.aclKey === 'pinv' && srv._data.isCancelled === false">
        <li *ngIf="this.acl.can('m3.8388608')" nz-menu-item (click)="showPrTransferModal()">
          Transfer from Purchase Requisition
        </li>
        <li *ngIf="this.acl.can('m3.16777216')" nz-menu-item (click)="showPoTransferModal()">
          Transfer from Purchase Order
        </li>
        <li *ngIf="this.acl.can('m3.33554432')" nz-menu-item (click)="showGrnTransferModal()">
          Transfer from Goods Received Note
        </li>
        <li nz-menu-divider></li>
      </ng-container>

      <ng-container *ngIf="srv.aclKey === 'cp' && srv._data.isCancelled === false">
        <li *ngIf="this.acl.can('m3.8388608')" nz-menu-item (click)="showPrTransferModal()">
          Transfer from Purchase Requisition
        </li>
        <li *ngIf="this.acl.can('m3.16777216')" nz-menu-item (click)="showPoTransferModal()">
          Transfer from Purchase Order
        </li>
        <li *ngIf="this.acl.can('m3.33554432')" nz-menu-item (click)="showGrnTransferModal()">
          Transfer from Goods Received Note
        </li>
        <li nz-menu-divider></li>
      </ng-container>
      <ng-container *ngIf="srv.aclKey === 'cpf' && srv._data.isCancelled === false">
        <li *ngIf="this.acl.can('m3.536870912')" nz-menu-item (click)="showCPTransferModal()">
          Transfer from Cash Purchase
        </li>
        <li nz-menu-divider></li>
      </ng-container>

      @if (showCopyFromButton()) {
      <li nz-menu-item (click)="onCopyFrom()">
        Copy from
      </li>
      <li nz-menu-divider></li>
      }
      <!-- Purchase # -->
      <ng-container *ngIf="(recurringAcls.indexOf(srv.aclKey) > -1) && id !== '0'">
        <li nz-menu-item (click)="handleMakeRecurringTransactionClick()">
          Make Recurring Transaction
        </li>
      </ng-container>

      @if (srv.parkAndPost && srv._data.documentStatus < 2) { @if (canApprove) { <li nz-menu-item class="hidden-pc"
        (click)="saveAndApprove()">Save & Approve
        </li>
        }
        @if (srv._data.documentStatus == 0) {
        <li nz-menu-item class="hidden-pc" (click)="submitForApproval()">Submit for Approval</li>
        }
        @if (srv._data.documentStatus == 0 && (srv._data.id == "00000000-0000-0000-0000-000000000000" || srv._data.id ==
        "0" || !srv._data.id)) {
        <li nz-menu-item (click)="saveAndDraft()">Save & Draft</li>
        }
        }

        @if (!srv.parkAndPost || !supportParkAndPost || canApprove) {
        <li nz-menu-item (click)="saveAndClose()">Save & Close</li>
        @if (srv.transactionType) {
        <li nz-menu-item (click)="saveAndNew()">Save & New</li>
        }
        <!-- <li nz-menu-item (click)="save()">Save</li> -->
        }
    </ul>
  </nz-dropdown-menu>
</ng-container>

<nz-modal [(nzVisible)]="voidVisible" nzTitle="Cancel Transaction" (nzOnCancel)="voidVisible = false"
  (nzOnOk)="this.void()" [nzOkLoading]="processingType === 'void'">
  <ng-container *nzModalContent>
    <form nz-form nzLayout="vertical">
      <nz-form-item>
        <nz-form-label nzFor="cancelledDate">Cancellation Date</nz-form-label>
        <nz-form-control>
          <app-date-input name="cancelledDate" [nzAllowClear]="false" [(ngModel)]="voidModel.cancelledDate">
          </app-date-input>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="cancelledRemark" nzRequired>Reason</nz-form-label>
        <nz-form-control nzErrorTip="Cancel Reason is Required">
          <app-memo-input name="cancelledRemark" [(ngModel)]="voidModel.cancelledRemark" [maxlength]="100">
          </app-memo-input>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="bouncedVisible" nzTitle="Mark as Bounced Cheque" (nzOnCancel)="bouncedVisible = false"
  (nzOnOk)="setBounced()" [nzOkLoading]="processingType === 'bounced'">
  <ng-container *nzModalContent>
    <form nz-form nzLayout="vertical">
      <nz-form-item>
        <nz-form-label nzFor="bouncedChequeDate">Bounced Cheque Date</nz-form-label>
        <nz-form-control>
          <app-date-input name="bouncedChequeDate" [nzAllowClear]="false" [(ngModel)]="bouncedModel.bouncedChequeDate">
          </app-date-input>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="trfVisible" [nzTitle]="trfTitle" (nzOnCancel)="trfVisible = false" (nzOnOk)="doDocTransfer()"
  [nzOkLoading]="processingType === 'transfer'" [nzWidth]="1000">
  <ng-container *nzModalContent>
    <!-- sales -->
    <app-sales-doc-transfer *ngIf="
        this.transferDocType === 'QT' ||
        this.transferDocType === 'SO' ||
        this.transferDocType === 'DO' ||
        this.transferDocType === 'CS'
      " [customerId]="this.customerId" [docType]="this.transferDocType" [transferredDocIds]="this.transferredDocIds"
      [transferToDocCode]="this.transferToDocCode"></app-sales-doc-transfer>
    <!-- purchase -->
    <app-purchase-doc-transfer *ngIf="
        this.transferDocType === 'PR' ||
        this.transferDocType === 'PO' ||
        this.transferDocType === 'GRN' ||
        this.transferDocType === 'CP'
      " [supplierId]="this.supplierId" [docType]="this.transferDocType" [transferredDocIds]="this.transferredDocIds"
      [transferToDocCode]="this.transferToDocCode"></app-purchase-doc-transfer>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="snsVisible" nzTitle="Send Transaction for..." [nzFooter]="null"
  (nzOnCancel)="snsVisible = false">
  <ng-container *nzModalContent>
    <div class="transact-send-group">
      <nz-row nzGutter="8">
        <nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
          <button type="button" class="sender-chooser" (click)="confirmSender(snsModel.action, false)" nz-button>
            <div class="content">
              <div class="icon">
                <i nz-icon nzIconfont="icon-send"></i>
              </div>
              <div class="title">Notification</div>
              <div class="description">Notify your customer
                @switch (snsModel.action) {
                @case ('email') {
                via email
                }
                @case ('whatsapp') {
                via WhatsApp
                }
                @case ('telegram') {
                via Telegram
                }
                @case ('link') {
                with a link
                }
                }
                about the transaction.
              </div>
            </div>
          </button>
        </nz-col>
        <nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
          <button type="button" class="sender-chooser" (click)="confirmSender(snsModel.action, true)" nz-button>
            <div class="icon">
              <i nz-icon nzIconfont="icon-collect-payment"></i>
            </div>
            <div class="title">Payment Collection</div>
            <div class="description">Send
              @switch (snsModel.action) {
              @case ('email') {
              an email
              }
              @case ('whatsapp') {
              a WhatsApp message
              }
              @case ('telegram') {
              a Telegram message
              }
              @case ('link') {
              a link
              }
              }
              to request payment for the transaction from your customer.
            </div>
          </button>
        </nz-col>
      </nz-row>
    </div>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="submitSelectionVisible" nzTitle="Send e-invoice by ..." [nzFooter]="null"
  (nzOnCancel)="submitSelectionVisible = false">
  <ng-container *nzModalContent>
    <div class="submit-einvoice-group">
      <nz-row nzGutter="8">
        <nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
          <button type="button" class="einv-submission-method" (click)="confirmSubmitEinvBy('peppol')" nz-button>
            <div class="content">
              <div class="icon">
                <i nz-icon nzIconfont="icon-peppol" style="font-size: 200%;"></i>
              </div>
              <div class="title">Submit via Peppol</div>
            </div>
          </button>
        </nz-col>
        <nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
          <button type="button" class="einv-submission-method" (click)="confirmSubmitEinvBy('qne')" nz-button>
            <div class="icon">
              <i nz-icon nzIconfont="icon-qne" style="font-size: 200%;"></i>
            </div>
            <div class="title">Submit via QNE</div>
          </button>
        </nz-col>
      </nz-row>
    </div>
  </ng-container>
</nz-modal>

<app-einvoice-validation-confirmation [onConfirm]="submitEInvoice"
  #einvConfirmationModal></app-einvoice-validation-confirmation>

<app-peppol-validation-confirmation [onConfirm]="submitPeppol"
  #peppolConfirmationModal></app-peppol-validation-confirmation>

<app-uuid-modal #uuidModal (statusChange)="eInvStatusChange.emit($event)"></app-uuid-modal>
<app-stock-item-einvoice-required-modal #stkEinvReqModal></app-stock-item-einvoice-required-modal>

<app-transaction-sender #sender [docType]="srv.aclKey" [reportTypes]="reportTypes" [showPreview]="true"
  [einvoiceControl]="einvControl" (modalClosed)="onModalClosed($event)"></app-transaction-sender>
<app-invoice-email-modal #emailPreview [reportTypes]="reportTypes"
  [einvoiceControl]="einvControl"></app-invoice-email-modal>
<app-recurring-transaction-modal #recurringTransaction
  (save)="recurringTransactionTemplateCallback()"></app-recurring-transaction-modal>

@if (showCopyToModal()) {
<app-copy-transaction-modal (requestApplyCopy)="onApplyCopy($event)" [id]="id" (closeModal)="showCopyToModal.set(false)"
  copyType="TO" />
}

@if (showCopyFromModal()) {
<app-copy-transaction-modal (requestApplyCopy)="onApplyCopy($event)" [id]="id"
  (closeModal)="showCopyFromModal.set(false)" copyType="FROM" />
}